import React, { useEffect, useState } from 'react';
import client, { apiCall } from '../../api/client';
import DataTable from '../../components/DataTable';
import StatusBadge from '../../components/StatusBadge';
import Loader from '../../components/Loader';

const PAGE_SIZE = 20;

export default function UsageLogs() {
  const [logs, setLogs] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const load = (pg = page) => {
    setLoading(true);
    apiCall(client.get('/rpc_logs/get_list', { params: { page: String(pg) } }))
      .then((data) => { setLogs(data.data); setTotalCount(data.totalCount); })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => load(page), [page]);

  const columns = [
    { key: 'createdAt', label: 'Time', render: (row) => new Date(row.createdAt).toLocaleString() },
    { key: 'network', label: 'Network' },
    { key: 'method', label: 'Method', render: (row) => <code>{row.method}</code> },
    { key: 'status', label: 'Status', render: (row) => <StatusBadge value={row.status} labels={{ true: 'Success', false: 'Failed' }} /> },
    { key: 'creditsCharged', label: 'Credits' },
    { key: 'latencyMs', label: 'Latency', render: (row) => `${row.latencyMs} ms` },
  ];

  const totalPages = Math.max(1, Math.ceil(totalCount / PAGE_SIZE));

  return (
    <div>
      <h1>Usage Logs</h1>
      {error && <div className="form-error">{error}</div>}
      <div className="card">
        {loading ? (
          <Loader label="Loading usage logs..." />
        ) : (
          <>
            <DataTable columns={columns} rows={logs} emptyMessage="No RPC calls made yet." />
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
              <button className="btn btn-outline btn-sm" disabled={page <= 1} onClick={() => setPage(page - 1)}>Prev</button>
              <span style={{ alignSelf: 'center', fontSize: 13, color: 'var(--text-muted)' }}>Page {page} of {totalPages}</span>
              <button className="btn btn-outline btn-sm" disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Next</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
